var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-tag',{staticClass:"feature-tag",attrs:{"color":"transparent"}},[_c('span',{staticClass:"inline-flex items-center justify-center rounded-full bg-white w-12 h-12 mr-4"},[_c('svg-icon',{staticClass:"w-8 h-8 stroke-green-a",attrs:{"pre-path":"itineraryUniversal","name":"ic-check"}})],1),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }